import type { PopupWithCampaignResponse } from '@coorum-research/shared-common/api-response/popup.schema'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { homeLauncherApi } from '../apis/home-launcher.api'

export function useHomeLauncher({ enabled, popupsClosed }: { enabled?: boolean, popupsClosed?: PopupWithCampaignResponse[] }) {
  const { getHomeLauncher } = homeLauncherApi()

  const { data: homeLauncher } = useQuery({
    queryKey: ['get-home-launcher'],
    queryFn: () => getHomeLauncher(),
    refetchOnWindowFocus: false,
    enabled,
  })

  const showHomeLauncher = useMemo(() => {
    if (!homeLauncher || homeLauncher.items.length === 0) {
      return false
    }
    // alwaysの時は常に表示
    if (homeLauncher.displayCondition === 'always') {
      return true
    }
    // whenClosePopups の時は閉じたPopupがある場合だけ有効
    if (homeLauncher.displayCondition === 'whenClosePopups' && popupsClosed && popupsClosed.length > 0) {
      return true
    }

    return false
  }, [homeLauncher, popupsClosed])

  return {
    homeLauncher,
    showHomeLauncher,
  }
}
